import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Login from "@/pages/Login";
import AdvisorDashboard from "@/pages/AdvisorDashboard";
import AdvisorClientDetail from "@/pages/AdvisorClientDetail";
import AdvisorResearch from "@/pages/AdvisorResearch";
import ClientPortal from "@/pages/ClientPortal";
import StockDetail from "@/pages/StockDetail";
import { getAuth } from "@/lib/auth";

function RequireAuth({ role, children }) {
  const auth = getAuth();
  if (!auth) return <Navigate to="/login" replace />;
  if (role && auth.role !== role) {
    return <Navigate to={auth.role === "advisor" ? "/advisor" : "/client"} replace />;
  }
  return children;
}

function RootRedirect() {
  const auth = getAuth();
  if (!auth) return <Navigate to="/login" replace />;
  return <Navigate to={auth.role === "advisor" ? "/advisor" : "/client"} replace />;
}

export default function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/advisor"
            element={
              <RequireAuth role="advisor">
                <AdvisorDashboard />
              </RequireAuth>
            }
          />
          <Route
            path="/advisor/research"
            element={
              <RequireAuth role="advisor">
                <AdvisorResearch />
              </RequireAuth>
            }
          />
          <Route
            path="/advisor/clients/:id"
            element={
              <RequireAuth role="advisor">
                <AdvisorClientDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/client"
            element={
              <RequireAuth role="client">
                <ClientPortal />
              </RequireAuth>
            }
          />
          <Route
            path="/stocks/:symbol"
            element={
              <RequireAuth>
                <StockDetail />
              </RequireAuth>
            }
          />
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
